import { useSelector } from 'react-redux'
import { RootState } from '../AppStore'

export function useAvailableRooms()
{
	return useSelector((root: RootState) => root.rooms.rooms)
}
export function useAvailableRoomsLookup()
{
	return useSelector((root: RootState) => root.rooms.roomsLookup)
}
